import { createRouter, createWebHistory } from 'vue-router'
import { ADMIN_TOKEN_KEY, clearAdminSession, verifyAdminSession } from '../utils/api'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/set',
    name: 'AdminLogin',
    component: () => import('../views/AdminLogin.vue')
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: () => import('../views/AdminDashboard.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) {
    return true
  }
  const token = localStorage.getItem(ADMIN_TOKEN_KEY)
  if (!token) {
    return { path: '/set', query: { redirect: to.fullPath } }
  }
  const valid = await verifyAdminSession()
  if (valid === false) {
    clearAdminSession()
    return {
      path: '/set',
      query: { redirect: to.fullPath, expired: '1' }
    }
  }
  return true
})

export default router
